import { ConfigProvider, type ConfigProviderProps } from 'antd';

import { useCurrentLocale } from '../hooks/useCurrentLocale.ts';

export function I18nConfigProvider(props: ConfigProviderProps) {
  const { children, ...rest } = props;
  const { antdLocale } = useCurrentLocale();

  return (
    <ConfigProvider locale={antdLocale} {...rest}>
      {children}
    </ConfigProvider>
  );
}
